/* The above code is a React component that renders a product item with its details such as image,
price, title, and add to cart button. It also includes functionality for adding/removing the product
from the wishlist and opening a quick view modal. The component uses data from the Redux store and
some utility functions to display the product information. */
import React, { useEffect, useState } from "react";
import "./ProductComponent.css";
import { CurrencySymbol } from "../../utils/Constants";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import ReactLoading from "react-loading";
import AddToCartComponent from "./AddToCartComponent";
import {
  handleAddToCartWrapperFnc,
  setSelectedProductEventHandler,
} from "../../utils/globalFunctions/cartFunctions";
import {
  AddToWishListHandler,
  RemoveWishListCartHandler,
} from "../../utils/globalFunctions/wishlistFunctions";
import { productImageFunc } from "../../utils/globalFunctions/productImageFunction";
import { productDiscountedPriceFunc } from "../../utils/globalFunctions/productDiscountPriceFunction";
import { defaultImage } from "../../utils/productUtils/ProductUtils";
import { ProductComponentCopyContainer } from "./ProductComponentCopyContainer";

const ProductComponentCopy = React.memo(
  ({
    productItemObj,
    id,
    triggerQuickViewModal,
    setshowHideLoginForm,
    setRelatedDiv,
    productType,
    withStockItemClassName,
    withoutStockItemClassName,
    imgKey,
    productNameKey,
    categoryIdKey,
    itemSize,
    sliderRef,
  }) => {
    const [currentProduct, setCurrentProduct] = useState(null);
    const dispatch = useDispatch();
    const { cartItems } = useSelector((state) => state);
    const { enableWishlist, cartItemWishlist, companyDetails, decimalPoints } =
      useSelector((state) => state);

    const [wishListProduct, setWishListProduct] = useState(null);
    const [showWishlist, setShowWishlist] = useState(true);
    const [loaded, setLoaded] = useState(false);

    const checkProductQtyWithVariantStock =
      (productItemObj.havevariants && productItemObj.isvariationhasstock > 0) ||
      (!productItemObj.havevariants && productItemObj.quantity > 0);
    // Re-factoring the Wishlist Functionality
    useEffect(() => {
      if (!cartItemWishlist && cartItemWishlist.length === 0) {
        setShowWishlist(false);
        setWishListProduct(null);
        return;
      }

      const [filteredWishlist] = cartItemWishlist.filter(
        ({ productId }) => productId === productItemObj.productid
      );

      setShowWishlist(!!filteredWishlist);
      setWishListProduct(filteredWishlist);
    }, [cartItemWishlist, productItemObj.productid]);

    const priceFormat = (price) => {
      let val2 = parseFloat(price).toFixed(2);
      return val2;
    };

    return (
      <div
        className={`${
          !checkProductQtyWithVariantStock
            ? withoutStockItemClassName
            : withStockItemClassName
        } productCard-container`}
        id={`${productType}homeProduct${productItemObj.productid}`}
        key={productItemObj.productid}
        onTouchMove={() => sliderRef.current.slickPause()}
        onTouchEnd={() => sliderRef.current.slickPlay()}
      >
        <ProductComponentCopyContainer>
          <div className={itemSize ? "items g-1 d-flex" : "items g-1 d-flex"}>
            <div className="item card w-100 p-2">
              <div
                className="text-center miniModel"
                onClick={() => {
                  setSelectedProductEventHandler(
                    productItemObj.productid,
                    dispatch,
                    productItemObj.productvarientid
                  );
                }}
              >
                {
                  // show or hide Wishlist
                  enableWishlist === 1 && (
                    <div className="col-sm-12 addToWish">
                      {showWishlist && wishListProduct ? (
                        <i
                          className="p-2 fs-5 fas fa-heart buttons remove wishlist_heart_icon"
                          style={{ color: "#de0000" }}
                          onClick={(e) => {
                            e.stopPropagation();
                            RemoveWishListCartHandler(
                              wishListProduct && wishListProduct.wishlistId,
                              setShowWishlist,
                              dispatch
                            );
                          }}
                        ></i>
                      ) : (
                        <i
                          className="p-2 fs-5 far fa-heart"
                          onClick={(e) => {
                            e.stopPropagation();
                            AddToWishListHandler(
                              productItemObj.productvarientid,
                              productItemObj.productid,
                              productItemObj[categoryIdKey],
                              productItemObj[productNameKey],
                              productItemObj[imgKey]
                                ? productItemObj[imgKey]
                                : defaultImage,
                              productItemObj.mrp,
                              productItemObj.sellingprice,
                              0,
                              setShowWishlist,
                              setshowHideLoginForm,
                              dispatch
                            );
                          }}
                        ></i>
                      )}
                    </div>
                  )
                }
                <Link
                  className="productCard"
                  to={`/productView/${productItemObj.productid}`}
                  state={productItemObj}
                  onContextMenu={() =>
                    setSelectedProductEventHandler(
                      productItemObj.productid,
                      dispatch,
                      productItemObj.productvarientid
                    )
                  }
                  onClick={() =>
                    setSelectedProductEventHandler(
                      productItemObj.productid,
                      dispatch,
                      productItemObj.productvarientid
                    )
                  }
                >
                  {/* <div className="ribbon" hidden={productItemObj.is_new_product}>
                  <div className="wrap-new">
                    <span className="ribbon6 fw-bold ">New</span>
                  </div>
                </div> */}
                  <img
                    style={{
                      display: loaded ? "block" : "none",
                      height: "163px",
                      objectFit: "cover",
                    }}
                    title={productItemObj[productNameKey]}
                    // loading="lazy"
                    onLoad={() => setLoaded(true)}
                    src={
                      productItemObj[imgKey] === "/No-image-found.jpg"
                        ? "/images/product-image-not-found-img.webp"
                        : productImageFunc(
                            productItemObj[imgKey],
                            companyDetails
                          )
                    }
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "/images/product-image-not-found-img.webp";
                    }}
                    className="pro-image-front img-fluid"
                    alt="product"
                  />

                  {!loaded && (
                    <div className="ImageLoader">
                      <ReactLoading
                        type="spinningBubbles"
                        color="var(--primary-color)"
                        height={100}
                        width={50}
                      />
                    </div>
                  )}
                </Link>
              </div>
              {/* <div className="product_card_img_container">
          <img
            style={{ display: loaded ? "block" : "none" }}
            title={productItemObj[productNameKey]}
            // loading="lazy"
            onLoad={() => setLoaded(true)}
            src={
              productImageFunc(productItemObj[imgKey], companyDetails) ||
              defaultImage
            }
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "icons/default-image.png";
            }}
            className="pro-image-front img-fluid"
            alt="product"
          />
        </div> */}
              <div className="product-details-boxsss">
                <div>
                  <Link
                    className="productTitle"
                    to={`/productView/${productItemObj.productid}`}
                    state={productItemObj}
                    onContextMenu={() =>
                      setSelectedProductEventHandler(
                        productItemObj.productid,
                        dispatch,
                        productItemObj.productvarientid
                      )
                    }
                    onClick={() => {
                      if (productItemObj.productid) {
                        setSelectedProductEventHandler(
                          productItemObj.productid,
                          dispatch,
                          productItemObj.productvarientid
                        );
                      }
                    }}
                  >
                    <h1 className="text-center px-2 py-1 miniModelTitle mb-2 product_name">
                      {productItemObj[productNameKey]}
                    </h1>
                  </Link>

                  {/* variant products --> Start --> new requirement */}
                  {/* {productItemObj.havevariants > 0 ? (
                  <div>
                    <select>
                      <option>34g</option>
                    </select>
                  </div>
                ) : (
                  <div></div>
                )} */}

                  {/* END */}
                </div>
                <div
                  className="product-variant-name-and-down-icon-parent"
                  style={{ minHeight: "30px", marginTop: "-9px" }}
                >
                  {!!productItemObj?.havevariants && (
                    <div
                      className="product-variant-name-and-down-icon"
                      onClick={() =>
                        handleAddToCartWrapperFnc(
                          productItemObj,
                          cartItems,
                          setSelectedProductEventHandler,
                          setRelatedDiv,
                          triggerQuickViewModal,
                          id,
                          productType,
                          productImageFunc(
                            productItemObj[imgKey],
                            companyDetails
                          ),
                          defaultImage,
                          checkProductQtyWithVariantStock,
                          currentProduct,
                          dispatch
                        )
                      }
                    >
                      <p className="product-variant-name trunkone">
                        {productItemObj?.variantname}
                      </p>
                      <div style={{ cursor: "pointer" }} className="down-icon">
                        <svg
                          width="30px"
                          height="30px"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                          <g
                            id="SVGRepo_tracerCarrier"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></g>
                          <g id="SVGRepo_iconCarrier">
                            {" "}
                            <path
                              d="M7 10L12 15L17 10"
                              stroke="#3a90bb"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></path>{" "}
                          </g>
                        </svg>
                      </div>
                    </div>
                  )}
                </div>
                {/* END */}
              </div>

              <div className="discounted-mrp-container">
                {
                  <div
                    className="mrp_and_discount_container"
                    style={{
                      visibility: productDiscountedPriceFunc(
                        productItemObj,
                        "sellingprice"
                      )
                        ? "visible"
                        : "hidden",
                    }}
                    // hidden={!productDiscountedPriceFunc(productItemObj, "sellingprice")}
                  >
                    <h5 className="mrp_product">
                      {CurrencySymbol}
                      {priceFormat(productItemObj.mrp || 0)}
                    </h5>
                    {/* <h6 className="discount_product">25% off</h6> */}
                  </div>
                }
              </div>
              <div className="sp_container">
                <h1 className="selling_price_product m-0">
                  {CurrencySymbol}
                  {priceFormat(productItemObj.sellingprice || 0)}
                </h1>
              </div>
              <div className="d-flex">
                <div className="mt-2">
                  {/* <button className="product_add_btn">ADD</button> */}
                  <AddToCartComponent
                    checkProductQtyWithVariantStock={
                      checkProductQtyWithVariantStock
                    }
                    productItemObj={productItemObj}
                    setSelectedProductEventHandler={
                      setSelectedProductEventHandler
                    }
                    setRelatedDiv={setRelatedDiv}
                    triggerQuickViewModal={triggerQuickViewModal}
                    id={id}
                    productType={productType}
                    productImage={productImageFunc(
                      productItemObj[imgKey],
                      companyDetails
                    )}
                    currentProduct={currentProduct}
                    setCurrentProduct={setCurrentProduct}
                    cartItems={cartItems}
                  />
                </div>
              </div>
            </div>
          </div>
        </ProductComponentCopyContainer>
      </div>
    );
  }
);

export default ProductComponentCopy;
